import { render, staticRenderFns } from "./RoomBuyInPopup.vue?vue&type=template&id=47ea5e20&scoped=true"
import script from "./RoomBuyInPopup.vue?vue&type=script&lang=js"
export * from "./RoomBuyInPopup.vue?vue&type=script&lang=js"
import style0 from "./RoomBuyInPopup.vue?vue&type=style&index=0&id=47ea5e20&lang=scss&scoped=true"
import style1 from "./RoomBuyInPopup.vue?vue&type=style&index=1&id=47ea5e20&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ea5e20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47ea5e20')) {
      api.createRecord('47ea5e20', component.options)
    } else {
      api.reload('47ea5e20', component.options)
    }
    module.hot.accept("./RoomBuyInPopup.vue?vue&type=template&id=47ea5e20&scoped=true", function () {
      api.rerender('47ea5e20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/RoomBuyInPopup.vue"
export default component.exports